<div class="welcome-message-form-container">
  <div class="welcome-message-header">
    <h3>{{ 'USER.EDIT_WELCOME_MESSAGE' | translate }}</h3>
    <button type="button" class="btn-close" (click)="cancel()" aria-label="Close"></button>
  </div>

  <div class="welcome-message-content">
    <div class="language-tabs-wrapper mb-3">
      <app-icam-tabs
        [tabs]="languageTabs"
        [selectedTabId]="selectedLanguage"
        [showArrow]="false"
        [spaced]="false"
        [minTabWidth]="'100px'"
        (tabChange)="onTabChange($event)"
      ></app-icam-tabs>
    </div>

    @if (isLoading) {
      <div class="text-center p-4">
        <div class="spinner-border text-primary" role="status">
          <span class="visually-hidden">{{ 'COMMON.LOADING' | translate }}</span>
        </div>
      </div>
    }

    @if (showSuccess) {
      <div class="alert alert-success mb-3">
        {{ 'USER.WELCOME_MESSAGE_SAVED' | translate }}
      </div>
    }

    @if (showError) {
      <div class="alert alert-danger mb-3">
        {{ errorMessage }}
      </div>
    }

    @if (!isLoading) {
      <form [formGroup]="messageForm" (ngSubmit)="saveMessage()">
        <input type="hidden" formControlName="id" />
        <div class="form-group mb-3">
          <div class="subject-field">
            <input
              id="subject"
              type="text"
              class="form-control"
              formControlName="subject"
              [placeholder]="'USER.WELCOME_SUBJECT_PLACEHOLDER' | translate"
            />
            @if (messageForm.get('subject')?.invalid && messageForm.get('subject')?.touched) {
              <div class="invalid-feedback d-block">
                @if (messageForm.get('subject')?.errors?.['maxlength']) {
                  <span>
                    {{ 'USER.MAX_LENGTH' | translate: { max: 200 } }}
                  </span>
                }
              </div>
            }
          </div>
          <textarea
            id="welcomeMessage"
            class="form-control"
            formControlName="message"
            rows="20"
            [maxlength]="null"
            [placeholder]="'USER.WELCOME_MESSAGE_PLACEHOLDER' | translate"
          ></textarea>
          <small class="form-text text-muted"> {{ messageForm.get('message')?.value?.length || 0 }}/1000 </small>
          @if (messageForm.get('message')?.invalid && messageForm.get('message')?.touched) {
            <div class="invalid-feedback d-block">
              @if (messageForm.get('message')?.errors?.['required']) {
                <span>
                  {{ 'USER.FIELD_REQUIRED' | translate }}
                </span>
              }
              @if (messageForm.get('message')?.errors?.['maxlength']) {
                <span>
                  {{ 'USER.MAX_LENGTH' | translate: { max: 1000 } }}
                </span>
              }
            </div>
          }
          <div class="form-text helper-text">
            {{ 'USER.WELCOME_MESSAGE_HELPER' | translate }}
          </div>
        </div>
        <div class="welcome-message-actions">
          <button type="button" class="btn btn-outline-secondary" (click)="cancel()">
            {{ 'COMMON.CANCEL' | translate }}
          </button>
          <button type="submit" class="btn btn-primary" [disabled]="messageForm.invalid || isSaving">
            @if (isSaving) {
              <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
            }
            {{ (isSaving ? 'COMMON.SAVING' : 'COMMON.SAVE') | translate }}
          </button>
        </div>
      </form>
    }
  </div>
</div>
